import { forwardRef, useState } from 'react'
import { useSnackbar } from "notistack"
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { CircularProgress, FormControl, Grid, InputLabel, OutlinedInput } from '@material-ui/core'
import { useEffect } from 'react'
import { DadosReciboAceite } from './styles'
import PDFView from "../../../components/lab/PdfView"
import SolicitacaoService from "../../../services/SolicitacaoService"
import { Skeleton } from '@material-ui/lab'
import webconfig from "../../../webconfig.json"

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function IndefereSolicitacao({
  arquivo,
  setArquivo,
  setRecarregarTriagens }) {

  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const [motivo, setMotivo] = useState('')
  const [motivoError, setMotivoSetorError] = useState({
    errorState: false,
    errorHelperText: ''
  })

  const SalvaIndeferimento = () => {
    setLoading(true)

    let dto = {
      IdSolicitacao: arquivo.solicitacao.id,
      Motivo: motivo
    }
    SolicitacaoService.SalvaIndeferimento(dto)
      .then(response => {
        setLoading(false)
        if (response.status === 200) {
          enqueueSnackbar(response.data, { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
        }
        else {
          enqueueSnackbar('Não foi possível salvar o deferimento da solicitação. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
        }

        //Ajustar aqui
        let dataAtual = new Date();
        setRecarregarTriagens(dataAtual.toString())
        handleFecharIndeferimento()

        //window.location.reload(false);
      })
      .catch(error => {
        setLoading(false)
        if (error.response && error.response.data) {
          if (error.response.status === 422) {
            try {
              const validacao = JSON.parse(error.response.data.detail);
              let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
              for (let i = 0; i < validacao.Validacoes.length; i++) {

                var itemValidado = validacao.Validacoes[i];
                for (var propriedadeValidada in itemValidado) {
                  mensagem += itemValidado[propriedadeValidada];
                }

                if ((i + 1) < validacao.Validacoes.length) {
                  mensagem += "; ";
                }
              }

              enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
            }
            catch (e) {
              if (error.response.data.detail) {
                enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
              }
            }
          }
          else if (error.response.status === 500) {
            enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
          }
          else {
            enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
          }
        }
        else {
          enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
        }
      })
  }

  const handleFecharIndeferimento = () => {
    setArquivo({
      open: false,
      solicitacao: {}
    })
    if (!loading) {
      setArquivo({
        open: false,
        solicitacao: {}
      })
    }
  }

  useEffect(() => {
  }, [arquivo.open])

  return (
    <Dialog
      open={arquivo.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleFecharIndeferimento}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      id="dialog-padrao"
    >
      <DialogTitle id="alert-dialog-slide-title" className="txt-primario">Indeferir Acesso de Gestor</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

            <DadosReciboAceite.PdfPreview id="DadosArquivoSolicitacao_PdfPreview">
              <PDFView
                url={arquivo.conteudoReciboBase64}
                nameFile={`${arquivo.solicitacao.nomeOrgaoJurisdicionado} - ${arquivo.solicitacao.nome}.pdf`}
              />
            </DadosReciboAceite.PdfPreview>

          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {
              loading
                ?
                <Skeleton id="skeleton-default-input" animation="wave" />
                :
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-motivo">
                    Motivo
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-motivo"
                    value={motivo}
                    onChange={event => setMotivo(event.target.value)}
                    error={motivoError.errorState}
                    helperText={motivoError.errorHelperText}
                    aria-describedby="outlined-peso-helper-text"
                    multiline={true}
                    rowsMax={5}
                  />
                </FormControl>
            }

          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleFecharIndeferimento} className="bg-alternativo-4 txt-alternativo-3" disabled={loading}>Cancelar</Button>
        <Button className="bg-primario txt-branco btn-salvar-default" onClick={() => loading ? ('') : SalvaIndeferimento()}>
          {
            loading
              ?
              <CircularProgress size={22} />
              :
              'Salvar'
          }
        </Button>
      </DialogActions>
    </Dialog>
  )
}